const featureItems = [
  { icon: 'ri-flashlight-line', title: '秒级更新', desc: '7×24小时不间断追踪，重大事件发生后30秒内推送，比热搜还快一步' },
  { icon: 'ri-global-line', title: '全网聚合', desc: '覆盖微博、抖音、小红书、B站等100+主流平台，一站式浏览全部热点' },
  { icon: 'ri-shield-check-line', title: '安全入口', desc: '所有入口经过人工安全审核，杜绝钓鱼网站，保护你的设备与隐私安全' },
  { icon: 'ri-smartphone-line', title: '多端适配', desc: '完美适配手机、平板、电脑，随时随地畅享吃瓜体验，无需下载任何App' },
  { icon: 'ri-group-line', title: '瓜友社区', desc: '百万瓜友实时互动，评论区畅聊八卦，分享你的吃瓜心得与独到见解' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">为什么选择51吃瓜网</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">五大核心优势，让你吃瓜快人一步</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item) => (
            <div key={item.title} className="bg-background-50 rounded-xl p-5 md:p-6 text-center">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}